/* eslint-disable react/prop-types */

import { CustomButton } from "../CustomButton/CustomButton";
import "./Header.css";

export const Header = ({ title, CallToAction, GoBackClick }) => {
    return (
        <div className="header-container">
            <div className="title-container">
                <CustomButton
                    content={"Go Back"}
                    onClick={GoBackClick}
                    direction={"left"}
                    size={"20px"}
                />
                <h2 className="title">{title}</h2>
            </div>
            <div className="header-cta">{CallToAction}</div>
        </div>
    );
};
